import { defaultClient as ApolloClient } from "@/main";
import {
  GET_ATHLETE_LIST,
  GET_ATHLETE_RESULTS,
  GET_RESULTS_LIST,
  GET_PERSON_COMMUNICATIONS,
  GET_CLUB_PERSON_RELATIONSHIP
} from "../../../graphql/athlete/athleteQ";
import {
  ADD_UPDATE_ATHLETE,
  ADD_ATHLETE_PERSON,
  DEL_ATHLETE,
  RESULT_MERGE,
  RESULT_DELETE,
  PERSON_COMMUNICATIONS_MUTATE,
  PERSON_COMMUNICATIONS_DELETE,
  CLUB_PERSON_REL_DELETE,
  CLUB_PERSON_REL_MERGE
} from "../../../graphql/athlete/athleteM";
import router from "../../../router/router";
import { GET_All_Club_Forms } from "../../../graphql/clubForms/clubFormsQ";

export const actions = {
  allClubFormData: async ({ commit }, payload) => {
    return ApolloClient.query({
      query: GET_All_Club_Forms,
      variables: payload
    })
      .then(({ data }) => {
        // Commit data from actions to state via mutations
        commit("setAllClubFormData", data.allClubForms.edges.map(edge => edge.node));
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  allAthlete: async ({ commit }, payload) => {
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_ATHLETE_LIST,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setAthleteList", data.allAthlete);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  addUpdateAthlete: async ({ commit, state }, payload) => {
    try {
      // Perform the mutation
      const response = await ApolloClient.mutate({
        mutation: ADD_UPDATE_ATHLETE,
        variables: payload,
      });

      console.log('GraphQL mutation response:', response.data);

      // Extract the athlete data from the response
      const updatedAthlete = response.data.athleteAddUpdate; // Adjust field based on your GraphQL schema

      // Update the Vuex state reactively

      // Ensure `edges` is at the root level
      const existingEdges = state.athleteList && state.athleteList.edges ? state.athleteList : [];

      const existingIndex = existingEdges.edges.findIndex(
        (edge) => edge.node.athleteId == updatedAthlete.edges.node.personId
      );
      //console.log("payload.athleteData");
      //console.log(payload.athleteData);
      payload.athleteData.updateDate = new Date().toISOString();
      let newEdges;
      if (existingIndex !== -1) {
        // eslint-disable-next-line no-unused-vars
        for (let [key, value] of Object.entries(
          existingEdges.edges[existingIndex].node
        )) {
          // eslint-disable-next-line no-unused-vars
          for (let [newKey, newValue] of Object.entries(payload.athleteData)) {
            if (key === newKey) {
              //console.log("test");
              existingEdges.edges[existingIndex].node[key] =
                payload.athleteData[newKey];
            }
          }
        }
      } else {
        //console.log(payload.athleteData);
        //console.log(updatedAthlete.edges);
        const newrecord = {
          node: {
            ...payload.athleteData, // Spread properties of athleteData into node
            email: payload.athleteData.email,
            athleteId: updatedAthlete.edges.node.personId,
            lastName: payload.athleteData.lastName,
            firstName: payload.athleteData.firstName
          }
        };
        //console.log(newrecord);
        // Push the new record into the edges array
        existingEdges.edges.push(newrecord);

        console.warn(
          "No index for update hook in addUpdateAthlete action, executing ADD record"
        );
      }

      console.log(existingEdges);
      // Commit the updated edges to the Vuex state
      commit("setAthleteList", existingEdges);

      commit("setLoading", false);
      return response.data; // Return the data if needed further

    } catch (err) {
      commit("setLoading", false);

      // Handle network and GraphQL errors
      if (err.networkError) {
        console.error('Network error:', err.networkError);
      }
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((graphqlError) => {
          console.error('GraphQL Error:', graphqlError.message);
        });
      }

      // Commit the error to Vuex and reject the promise
      commit("setError", err);
      console.error('Error in addUpdateAthlete action. Full info =>', err);
      return Promise.reject(err);
    }
  },

  tryoutRegistration: async ({ commit }, payload) => {
    return ApolloClient.mutate({
      mutation: ADD_ATHLETE,
      variables: payload
    })
      .then(({ data }) => {
        console.log(data);
        router.push("/").catch(err => {
          commit("setError", err);
        });
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        commit("setError", err);
        console.error(`Error in signUpUser action. Full info => ${err}`);
      });
  },

  DeleteAthlete: async ({ commit, state, dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: DEL_ATHLETE,
      variables: payload,
      update: cache => {
        try {
          // const data = cache.readQuery({
          //   query: GET_ATHLETE_LIST
          // });
          //console.log(state.athleteList);
          //console.log(payload);
          const existingEdges = state.athleteList.edges.filter(
            item => +item.node.athleteId !== +payload.personId
          );
          //console.log(existingEdges);
          commit("setAthleteList", { edges: existingEdges });

          // cache.writeQuery({
          //   query: GET_ATHLETE_LIST,
          //   data
          // });
        } catch (error) {
          console.error(
            `Error in DeleteAthlete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        //dispatch("allAthlete");
      })
      .catch(err => {
        console.error(`Error in DeleteAthlete action. Full info: ${err}`);
      });
  },
  allResults: async ({ commit }, payload) => {
    commit("setLoading", true);
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_ATHLETE_RESULTS,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit(
          "setAthleteOfficialResults",
          data.allResults.edges.filter(result => result.node.isOfficial)
        );
        commit("setAthleteResults", data.allResults);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  allResultsList: async ({ commit }, payload) => {
    commit("setLoading", true);
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_RESULTS_LIST,
      variables: payload
    })
      .then(({ data }) => {
        commit("setResultsList", data.resultsList);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  resultMerge: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: RESULT_MERGE,
      variables: payload,
      update: (cache, { data: { resultMerge } }) => {
        try {
          console.log("payload", payload);
          console.log("resultMerge", resultMerge);
          const data = cache.readQuery({
            query: GET_RESULTS_LIST
          });
          data.resultsList.push(resultMerge);
          cache.writeQuery({
            query: GET_RESULTS_LIST,
            data
          });
        } catch (error) {
          console.error(
            `Error in resultMerge update hook. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allResultsList");
      })
      .catch(err => {
        console.error(`Error in resultMerge action. Full info => ${err}`);
      });
  },
  DeleteResult: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: RESULT_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_RESULTS_LIST
          });
          data.resultsList = data.resultsList.filter(
            el => +el.resultId !== +payload.resultId
          );
          cache.writeQuery({
            query: GET_RESULTS_LIST,
            data
          });
        } catch (error) {
          console.error(
            `Error in DeleteResult update hook. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allResultsList");
      })
      .catch(err => {
        console.error(`Error in DeleteResult action. Full info => ${err}`);
      });
  },

  allPersonCommunications: async ({ commit }, payload) => {
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_PERSON_COMMUNICATIONS,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setPersonCommunications", data.allPersonCommunications);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  personCommunicationsMerge: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: PERSON_COMMUNICATIONS_MUTATE,
      variables: payload,
      update: (cache, { data }) => {
        try {
          // Log the entire mutation response for debugging
          console.log("Mutation response:", data);
  
          // Safely extract the node from the response
          const newNode = data.personCommunicationsMutate.edges.node;
          if (!newNode) {
            console.error("No node found in the mutation response");
            return;
          }
  
          // Read the current data from the Apollo cache
          const existingData = cache.readQuery({
            query: GET_PERSON_COMMUNICATIONS
          });
  
          // Extract the list of current communications (nodes)
          let existingNodes = existingData.allPersonCommunications.edges.map(edge => edge.node);
  
          // Filter out the communication if it's being updated
          existingNodes = existingNodes.filter(comm => comm.seqNo !== newNode.seqNo);
  
          // Add the new or updated communication node
          existingNodes.push(newNode);
  
          // Wrap nodes back into edges for cache update
          const newData = {
            allPersonCommunications: {
              ...existingData.allPersonCommunications,
              edges: existingNodes.map(node => ({ node }))
            }
          };
  
          // Write the updated data back to Apollo cache
          cache.writeQuery({
            query: GET_PERSON_COMMUNICATIONS,
            data: newData
          });
  
          // Commit to Vuex store to update the state
          commit("setPersonCommunications", newData.allPersonCommunications.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in personCommunicationsMerge update hook: ${error}`);
        }
      }
    })
    .then(() => {
      // Dispatch another action if needed (e.g., refetching or updating related state)
      dispatch("allPersonCommunications");
    })
    .catch(err => {
      console.error(`Error in personCommunicationsMerge action: ${err}`);
    });
  },

  personCommunicationsDelete: async ({ dispatch, commit }, { seqNo }) => {
    return ApolloClient.mutate({
      mutation: PERSON_COMMUNICATIONS_DELETE,
      variables: { seqNo },
      update: (cache, { data }) => {
        try {
          // Log the mutation response
          console.log("Delete Mutation Response:", data);
  
          // Check if the mutation was successful
          const success = data.personCommunicationsDelete.success;
          if (!success) {
            console.error("Deletion was unsuccessful:", data.personCommunicationsDelete.message);
            return;
          }
  
          // Read current data from the Apollo cache
          const existingData = cache.readQuery({
            query: GET_PERSON_COMMUNICATIONS
          });
  
          // Filter out the deleted communication from the existing nodes
          const updatedNodes = existingData.allPersonCommunications.edges.filter(
            edge => edge.node.seqNo !== seqNo
          );
  
          // Update the Apollo cache with the new data
          const newData = {
            allPersonCommunications: {
              ...existingData.allPersonCommunications,
              edges: updatedNodes
            }
          };
  
          // Write the updated data back to Apollo cache
          cache.writeQuery({
            query: GET_PERSON_COMMUNICATIONS,
            data: newData
          });
  
          // Commit the updated data to the Vuex store
          commit("setPersonCommunications", newData.allPersonCommunications.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in personCommunicationsDelete update hook: ${error}`);
        }
      }
    })
    .then(() => {
      // Optionally dispatch another action (e.g., refetching the data or updating related state)
      dispatch("allPersonCommunications");
    })
    .catch(err => {
      console.error(`Error in personCommunicationsDelete action: ${err}`);
    });
  },

  allClubPersonRel: async ({ commit }, payload) => {
    //use ApolloClient to fire graphql query
    console.log(payload);
    return ApolloClient.query({
      query: GET_CLUB_PERSON_RELATIONSHIP,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        console.log(data.allClubPersonRel);
        commit("setClubPersonRelationship", data.allClubPersonRel);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  clubPersonRelMerge: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: CLUB_PERSON_REL_MERGE,
      variables: payload,
      update: (cache, { data }) => {
        try {
          // Log the entire mutation response for debugging
          console.log("Mutation response:", data);
  
          // Safely extract the node from the response
          const newNode = data.clubPersonRelMutate.edges.node;
          if (!newNode) {
            console.error("No node found in the mutation response");
            return;
          }
  
          // Read the current data from the Apollo cache
          const existingData = cache.readQuery({
            query: GET_CLUB_PERSON_RELATIONSHIP
          });
  
                    let existingNodes = existingData.allClubPersonRel.edges.map(edge => edge.node);
  
          // Filter out the record if it's being updated
          existingNodes = existingNodes.filter(comm => comm.seqNo !== newNode.seqNo);
  
          // Add the new or updated node
          existingNodes.push(newNode);
  
          // Wrap nodes back into edges for cache update
          const newData = {
            allClubPersonRel: {
              ...existingData.allClubPersonRel,
              edges: existingNodes.map(node => ({ node }))
            }
          };
  
          // Write the updated data back to Apollo cache
          cache.writeQuery({
            query: GET_CLUB_PERSON_RELATIONSHIP,
            data: newData
          });
  
          // Commit to Vuex store to update the state
          commit("setClubPersonRelationship", newData.allClubPersonRel.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in clubPersonRelMerge update hook: ${error}`);
        }
      }
    })
    .then(() => {
      // Dispatch another action if needed (e.g., refetching or updating related state)
      dispatch("allClubPersonRel");
    })
    .catch(err => {
      console.error(`Error in clubPersonRelMerge action: ${err}`);
    });
  },

clubPersonRelDelete: async ({ dispatch, commit }, { seqNo }) => {
    return ApolloClient.mutate({
      mutation: CLUB_PERSON_REL_DELETE,
      variables: { seqNo },
      update: (cache, { data }) => {
        try {
          // Log the mutation response
          console.log("Delete Mutation Response:", data);
  
          // Check if the mutation was successful
          const success = data.clubPersonRelDelete.success;
          if (!success) {
            console.error("Deletion was unsuccessful:", data.clubPersonRelDelete.message);
            return;
          }
  
          // Read current data from the Apollo cache
          const existingData = cache.readQuery({
            query: GET_CLUB_PERSON_RELATIONSHIP
          });
  
          // Filter out the deleted communication from the existing nodes
          const updatedNodes = existingData.allClubPersonRel.edges.filter(
            edge => edge.node.seqNo !== seqNo
          );
  
          // Update the Apollo cache with the new data
          const newData = {
            allClubPersonRel: {
              ...existingData.allClubPersonRel,
              edges: updatedNodes
            }
          };
  
          // Write the updated data back to Apollo cache
          cache.writeQuery({
            query: GET_CLUB_PERSON_RELATIONSHIP,
            data: newData
          });
  
          // Commit the updated data to the Vuex store
          commit("setClubPersonRel", newData.allClubPersonRel.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in clubPersonRelDelete update hook: ${error}`);
        }
      }
    })
    .then(() => {
      // Optionally dispatch another action (e.g., refetching the data or updating related state)
      dispatch("allClubPersonRel");
    })
    .catch(err => {
      console.error(`Error in clubPersonRelDelete action: ${err}`);
    });
  }  
   
  
};
